<template>
    <div :class="outerClasses">
        <div :class="innerClasses">
            <div :class="fieldOuterClasses" v-if="page.title || (pageStats && pageStats.total)">
                <div :class="fieldInnerClasses">
                    <h2 v-if="page.title" class="mb-2">{{ page.title }} <small class="text-muted" v-if="pageStats && pageStats.total > 0">{{ pageStats.graded }}/{{ pageStats.total }}</small></h2>
                    <h2 v-else-if="pageStats && pageStats.total > 0" class="mb-2">{{ $t('page-n' , {'n': 1}) }} <small class="text-muted" v-if="pageStats && pageStats.total > 0">{{ pageStats.graded }}/{{ pageStats.total }} answered</small></h2>
                </div>
            </div>
            <!-- Start of grid -->
            <div v-for="(row, rowIndex) in page.grid" :key="rowIndex" class="row">
                <div v-for="(col, colIndex) in row" :key="colIndex" v-bind:class="getColClass(col)">
                <!-- Start of grid -->
                    <template v-for="(field, fieldIndex) in col.fields">
					    <div :key="fieldIndex" :id="'question-' + field.id" :class="fieldOuterClasses" v-if="!showOnlyEmpty || field.value === null || field.value === '' || field.value === undefined || focusedFieldId === field.id" @focusin="focusedFieldId = field.id" @focusout="focusedFieldId = null">
                            <div :class="fieldInnerClasses">
                                <input type="hidden" name="field_id" v-bind:value="field.id" />
                                <FormField
                                    :field="field"
                                    :type="field.type"
                                    :readonly="submittercanedittheirfields ? setPermissionForTest(field.permission) : readonly"
                                    :viewAs="submittercanedittheirfields ? setViewForTest(field.permission) : viewAs"
                                    :formresponse="formresponse"
                                    :allFieldsById="allFieldsById"
                                    @limit-exceeded="limitExceeded"
                                ></FormField>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import FormField from "../FormField";
export default {
	components: {
		FormField
	},
	name: 'FormGrid',
	props: ['page','readonly', 'viewAs', 'formresponse','submittercanedittheirfields','showOnlyEmpty','pageStats'],
	data() {
		return { focusedFieldId: null };
	},
	created() {
		this.normalizeFieldValues();
	},
	methods: {
		// Some stored forms have select/grade/mark fields whose `value` key is entirely
		// missing (saved back when "untouched" was the JSON-unsafe `undefined`, which
		// JSON.stringify drops), or still literally `undefined` in memory. Either way Vue 2
		// can't react to the key being added later, so the field's button/control silently
		// stops updating. Patch it to the real default (`[]` for multiselect, `null`
		// otherwise) here, once, wherever this grid renders.
		normalizeFieldValues(){
			const inputTypes = ['text', 'textarea', 'number', 'select', 'grade', 'mark', 'multiselect', 'bool', 'fileupload', 'signature', 'richtext', 'datetime', 'date', 'polararea'];
			this.page.grid?.forEach(row => {
				row?.forEach(col => {
					col.fields?.forEach(field => {
						if(field && inputTypes.includes(field.type) && (!Object.hasOwnProperty.call(field, 'value') || field.value === undefined)){
							this.$set(field, 'value', field.type === 'multiselect' ? [] : null);
						}
					});
				});
			});
		},
		getColClass(col){
			return 'col-md-' + col.width;
			// style="border: 1px dashed #EEE; padding: 10px 10px;"
		},
        setPermissionForTest(permission){
            if (permission == 'submitter') return false;
            return true;
        },
        setViewForTest(permission) {
            if (permission == 'submitter') return 'submitter';
            return 'signer';
        },
        limitExceeded(payload){
            this.$emit("limit-exceeded", payload);
        }
	},
    computed: {
       
        allFieldsById() {
            const map = [];
            // Traverse this.formresponse and collect all fields by id
            // const pages = this.formresponse?.form?.settings?.pages ||
            //             this.formresponse?.settings?.pages ||
            //             this.formresponse?.pages || [];

            // pages.forEach(page => {
            this.page.grid?.forEach(row => {
                row?.forEach(col => {
                col.fields?.forEach(field => {
                    if (field?.id) map.push(field);
                });
                });
            });
            //});
            return map;
        },

        outerClasses() {
            if(this.page.style == 'cardperquestion'){
                return ''
            } else {
                return 'card mb-8'
            }
        },

        innerClasses() {
            if(this.page.style == 'cardperquestion'){
                return ''
            } else {
                return 'card-body'
            }
        },

        fieldOuterClasses() {
            if(this.page.style == 'cardperquestion'){
                return 'card mb-8 form-field-card'
            } else {
                return ''
            }
        },

        fieldInnerClasses() {
            if(this.page.style == 'cardperquestion'){
                return 'card-body'
            } else {
                return ''
            }
        }
    }
};
</script>
